import dayjs from "dayjs"

import { WAREHOUSE_TYPE_TO_LABEL } from "./constants"
import type { WarehouseFormValues } from "./schemas"
import type { WarehouseFormPayload } from "./types"

import type { WarehouseType } from "@/graphql/codegen/graphql"
import { toNumberOrNull, toStringOrNull } from "@/utils/forms"

export const getWarehouseTypeLabel = (warehouseType?: WarehouseType | null): string => {
  if (!warehouseType) return ""

  return WAREHOUSE_TYPE_TO_LABEL.get(warehouseType) ?? warehouseType
}

export const formatTime = (time: string): string => dayjs(`2000-01-01T${time}`, "YYYY-MM-DDTHH:mm:ss").format("hh:mm A")

export const serializeWarehouseForm = (formValues: WarehouseFormValues): WarehouseFormPayload => ({
  externalSystemId: formValues.externalSystemId,
  type: formValues.type!,
  receivingHoursFrom: formValues.receivingHoursFrom,
  receivingHoursTo: formValues.receivingHoursTo,
  shippingHoursFrom: formValues.shippingHoursFrom,
  shippingHoursTo: formValues.shippingHoursTo,
  specialInstructions: toStringOrNull(formValues.specialInstructions),
  monthlyAccrualFee: toNumberOrNull(formValues.monthlyAccrualFee),
  inboundFee: toNumberOrNull(formValues.inboundFee),
  outboundFee: toNumberOrNull(formValues.outboundFee),
  miscellaneousFees: formValues.miscellaneousFees
    .filter((fee) => fee.type && fee.amount)
    .map((fee) => ({
      type: fee.type,
      amount: Number(fee.amount),
    })),
})
